var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5042 7.99333L18.8834 9.61412C18.7181 9.77937 18.4509 9.77937 18.2857 9.61412L14.3831 5.71157C14.2179 5.54633 14.2179 5.27913 14.3831 5.11388L16.0039 3.49309C16.6614 2.83564 17.7302 2.83564 18.3912 3.49309L20.5042 5.6061C21.1651 6.26355 21.1651 7.33236 20.5042 7.99333ZM12.9909 6.50614L3.75834 15.7387L3.01299 20.0104C2.91103 20.587 3.41379 21.0862 3.99038 20.9878L8.26209 20.2389L17.4946 11.0064C17.6599 10.8411 17.6599 10.5739 17.4946 10.4087L13.5921 6.50614C13.4233 6.3409 13.1561 6.3409 12.9909 6.50614ZM7.36205 14.9476C7.16868 14.7542 7.16868 14.4448 7.36205 14.2515L12.7764 8.83713C12.9698 8.64376 13.2792 8.64376 13.4725 8.83713C13.6659 9.0305 13.6659 9.33989 13.4725 9.53326L8.05818 14.9476C7.86481 15.141 7.55542 15.141 7.36205 14.9476ZM6.09284 17.9044H7.78043V19.1806L5.51273 19.5779L4.41931 18.4845L4.8166 16.2168H6.09284V17.9044Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.05a515f8336b2e66f4b6815a9f0d9f9e.svg";
export { ForwardRef as ReactComponent };